import fetchClient, { ApiResponse } from '@/api/api-client'

import { AffUser, AffUserData } from './types/AffUser'
import { Coupon } from './types/Coupon'

export async function getAffUserByRefNum(refNum: string): Promise<AffUser> {
  try {
    const res = await fetchClient.get(`affiliate/${refNum}`)
    return res.data.data.response
  } catch (err) {
    throw err
  }
}

export async function listAffiliateUsers() {
  try {
    const res = await fetchClient.get<ApiResponse<{ response: AffUser[] }>>('/affiliatePage')
    return res.data.data.response
  } catch (error) {
    // console.log("listAffiliateUsers - error", error)
    throw error
  }
}

export async function getAffUserById(refUserId: string): Promise<AffUser> {
  try {
    const res = await fetchClient.get(`/affiliate/refId/${refUserId}`)
    // console.log("getRefById - res", res)
    return res.data
  } catch (err) {
    // console.log("getRefById - err", err)
    throw err
  }
}

export async function sendEmailAffReq(data: string) {
  const payload = { data }
  try {
    const res = await fetchClient.post(`/sendEmail`, payload)
    return res.data
  } catch (err) {
    throw err
  }
}

export async function getAffiliateUserData() {
  try {
    const res = await fetchClient.get<ApiResponse<AffUserData>>(`/affiliate`)
    return res.data.data
  } catch (err) {
    throw err
  }
}
export async function createAffUser(data: unknown) {
  try {
    const payload = {
      data,
    }

    const res = await fetchClient.post('/affiliate', payload)
    // console.log("createRef - res", res)
    return res.data
  } catch (err) {
    // console.log("createRef - err", err)
    throw err
  }
}
export async function deleteRefUser(refUserId: string) {
  try {
    const res = await fetchClient.delete(`/affiliate/${refUserId}`)
    // console.log("deleteRefUser - res", res)
    return res.data
  } catch (err) {
    // console.log("deleteRefUser - err", err)
    throw err
  }
}

export async function getCouponByAffUserId(refUserId: string): Promise<Coupon[]> {
  try {
    const res = await fetchClient.post(`/coupons/byrefuserid`, { id: refUserId })
    return res.data.data
  } catch (error) {
    throw error
  }
}
export async function updateAffUser(refUserId: string, data: unknown) {
  try {
    const payload = {
      data,
    }

    const res = await fetchClient.patch(`/affiliate/${refUserId}`, payload)
    // console.log("updateRef - res", res)
    return res.data
  } catch (err) {
    // console.log("updateRef - err", err)
    throw err
  }
}
